import { default as processClassNames } from 'classnames'

interface AcquisitionViewSiteNavSectionProps {
  classNames: any
}

const AcquisitionViewSiteNavSection = ({
  classNames,
}: AcquisitionViewSiteNavSectionProps) => (
  <ul className={processClassNames(classNames)} />
)

export default AcquisitionViewSiteNavSection
